import { StyledFormItem } from './Form.style';

export function FormItem(props: any) {
  return <StyledFormItem {...props} />;
}
